import { ApiResponse } from '@monorepo/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type typeMode = 'alert' | 'confirm';

type typeAlertModalStateBase<T = any> = {
    execution?: Function;
    executionOnCancelling?: Function;
    response?: ApiResponse<T>;
};

type typeAlertModalState = typeAlertModalStateBase & {
    animation?: number;
    message: string;
    mode: typeMode;
    showingAlertModal?: boolean;
    title: string;
}

const initialState: typeAlertModalState = {
    message: '',
    mode: 'alert',
    showingAlertModal: false,
    title: ''
};

const alertModalSlice = createSlice({
    name: 'alertModal',
    initialState,
    reducers: {
        closeAlertModalReducer: (state) => {
            state = {
                animation: undefined,
                message: '',
                mode: 'alert',
                showingAlertModal: false,
                title: ''
            }
            return state;
        },
        setAlertResponse: (state, action: PayloadAction<typeAlertModalStateBase>) => {
            if (!action.payload.response) {
                return;
            }
            state = {
                animation: action.payload.response.success ? 1 : 2,
                execution: action.payload.execution,
                executionOnCancelling: action.payload.executionOnCancelling,
                message: action.payload.response.message.description,
                mode: 'alert',
                showingAlertModal: true,
                title: action.payload.response.message.title
            }
            return state;
        },
        setValuesAndOpenAlertModalReducer: (state, action: PayloadAction<typeAlertModalState>) => {
            state = {
                animation: action.payload.animation,
                execution: action.payload.execution,
                executionOnCancelling: action.payload.executionOnCancelling,
                message: action.payload.message ?? '',
                mode: action.payload.mode ?? 'alert',
                showingAlertModal: true,
                title: action.payload.title ?? ''
            }
            return state;
        }
    }
});

export const alertModalReducer = alertModalSlice.reducer;

export const closeAlertModalReducer = alertModalSlice.actions.closeAlertModalReducer;
export const setAlertResponse = alertModalSlice.actions.setAlertResponse;
export const setValuesAndOpenAlertModalReducer = alertModalSlice.actions.setValuesAndOpenAlertModalReducer;
